<div class="loader-container is-{{orientation()}}" [style.zIndex]="zIndex()">
  <mulo-spinner></mulo-spinner>
  @if (message) {
    <div class="loader-message">
      <span [innerHTML]="message"></span>
    </div>
  }
</div>
